import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import type { MutationError } from '~/types/form';
import { PACKAGE_SESSION_SAVE } from '~/endpoints';
import { handleErrorResponse } from '~/helpers/api';
import { PackageSessionSaveRequest } from '~/types/api';
import { PackageSessionSaveResponseSchema } from '~/validation/api/packageSessionSaveResponse';

const sendPackageSessionSave = async (obj: PackageSessionSaveRequest) => {
  try {
    const response = await axios.post(PACKAGE_SESSION_SAVE, obj);

    const json = response.data;

    return PackageSessionSaveResponseSchema.parse(json);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw await handleErrorResponse(error.response);
    }

    throw error;
  }
};

export default function usePackageSessionSave() {
  return useMutation<any, MutationError, PackageSessionSaveRequest>({
    mutationFn: (obj) => {
      return sendPackageSessionSave(obj);
    },
  });
}
